import { Seo } from 'ui-components'

import { Explore } from './Explore'
import { getServerSideProps } from './getServerSideProps'

export type AppProps = Awaited<ReturnType<typeof getServerSideProps>>['props']

export const App = (props: AppProps) => {
  return (
    <>
      <Seo
        title='Mapstack Community - Discover the best community contributed maps'
        description='Explore the best maps chosen by the Mapstack community. Dive into a curated collection of the most insightful and visually compelling maps. Discover top-rated maps that highlight diverse data sets and powerful visualizations. Start exploring now!'
      />
      <Explore {...props} />
    </>
  )
}
